<template>
  <div class="satellites">
    <v-container class="my-5">
      <v-row class="ml-1 mb-4">
        <v-col cols="12" sm="12" md="4" lg="3" class="mt-1">
          <v-text-field v-model="findTxt" hide-details outlined dense clearable label="Find" prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-select v-model="statusSelect" :items="statusItems" label="Status (Filter)" multiple chips hide-details clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="statusSelect.splice(statusSelect.indexOf(data.item), 1)" close>
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="d-none d-md-block" md="4" lg="3">
          <v-select v-model="freqSelect" :items="freqItems" label="Frequency" multiple hide-details chips clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="freqSelect.splice(freqSelect.indexOf(data.item), 1)" close>
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-img
            height="150"
            contain
            src="https://static.tinygs.com/satellites/Surveillance.jpg"
            alt="Surveillance mode image"
          ></v-img>
        </v-col>
        <v-col cols="12" md="9" class="d-flex align-center">
          <p class="body-1">
            When no supported satellites are overhead, TinyGS stations enter surveillance mode. In this mode, they actively search for new satellite signals or investigate potential new satellites.
          </p>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="satellites"
        :search="findTxt"
        class="elevation-1"
        item-key="name"
        @click:row="navigateToSatellite"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, -1]
        }"
        :loading="loadingSatellites"
        loading-text="Loading satellite data..."
        no-data-text="No satellites found matching your criteria."
        hover
        :sort-by="['lastPacketTime']"
        :sort-desc="[true]"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.confirmedPackets="{ item }">
          {{ item.confirmedPackets.toLocaleString() }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.frames="{ item }">
          {{ item.frames.toLocaleString() }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.lastPacketTime="{ item }">
          {{ item.lastPacketTime ? formatLaunchDate(item.lastPacketTime) : 'N/A' }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <!-- <template v-slot:item.launchDate="{ item }">
          {{ item.launchDate ? formatLaunchDate(item.launchDate) : 'N/A' }}
        </template> -->
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.configurations="{ item }">
          {{ formatConfigurations(item.configurations) }}
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { getCurrentInstance } from 'vue'
import { useSatelliteSurveillance } from '../composables/useSatelliteSurveillance'

const { proxy } = getCurrentInstance()
const router = proxy.$router
const {
  findTxt,
  statusSelect,
  statusItems,
  freqSelect,
  freqItems,
  loadingSatellites,
  headers,
  getSatellites,
  formatLaunchDate,
  formatConfigurations,
  satellites
} = useSatelliteSurveillance()

function navigateToSatellite(item) {
  if (router && typeof router.push === 'function') {
    router.push(`/satellite/${item.name}`)
  }
}

onBeforeMount(() => {
  getSatellites()
})
</script>

<style>
/* Estilos globales que aún pueden ser útiles */
/* .subheading { ... } */

/* Estilos para los chips de status en los filtros (ya no en la tabla) */
.Supported, .SupportedSL {
  background-color: #4CAF50 !important;
  color: black !important;
}

.Future {
  background-color: #82B1FF  !important;
  color: black !important;
}

.Experimental {
  background-color: #FFC107  !important;
  color: black !important;
}

.Inactive {
  background-color: #FF5252  !important;
  color: black !important;
}

/* Estilo para que la fila de la tabla parezca clickeable */
.v-data-table tbody tr:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.05) !important;
}
</style>